import React from 'react'
import HomeSlider from './components/HomeSlider'
import TabSection from './components/TabSection'
import TablesGifSection from './components/TablesGifSection'
import LoginPopup from './components/LoginPopup'

const Home = () => {
  return (
 <>
     
        <HomeSlider />
        <TabSection />
        <TablesGifSection />
 </>
  )
}

export default Home